import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { btlApplicationFormApi } from '../../../api/btlApplicationForm';
import { AffordabilityRunOutput } from '../../../api/btlApplicationForm/types';

export const useGetAffordabilityCheck = (
  applicationId: string,
): UseQueryResult<{ buyToLetOutput: AffordabilityRunOutput }[]> =>
  useQuery(['btl-application-get-affordability-check', applicationId], () =>
    applicationId ? btlApplicationFormApi.getAffordabilityRuns(applicationId) : null,
  );
